module.exports = __webpack_public_path__ + "img/default-hero.a2df5171.svg";